<div class="ai-chatbot-prompt-box-container">
  <div class="ai-chatbot-prompt-box">
    <div class="ai-chatbot-prompt-box-input-area">
      <textarea
        #messageInput
        id="messageInput"
        matInput
        placeholder="I want a presentation of..."
        tabindex="0"
        (keydown)="onKeyDown($event)"
      ></textarea>
      <button
        mat-icon-button
        class="ai-chatbot-prompt-box-input-area-send-stop-button"
        aria-label="Send message"
        tabindex="0"
        (click)="sendMessage()"
        *ngIf="!aiChatbotService.isProcessing"
      >
        <mat-icon svgIcon="ai-chatbot-send"></mat-icon>
      </button>
      <button
        mat-icon-button
        class="ai-chatbot-prompt-box-input-area-send-stop-button"
        aria-label="Stop processing"
        tabindex="0"
        (click)="aiChatbotService.stopProcessing()"
        *ngIf="aiChatbotService.isProcessing"
      >
        <mat-icon svgIcon="ai-chatbot-stop"></mat-icon>
      </button>
    </div>

    <div class="ai-chatbot-prompt-box-categories">
      <ai-chatbot-category-chip
        label="Style"
        icon="layout"
        [options]="aiChatbotService.styles"
        (valueChange)="onStyleChange($event)"
      ></ai-chatbot-category-chip>

      <ai-chatbot-category-chip
        label="Content"
        icon="content"
        [options]="aiChatbotService.contents"
        [isMultiSelect]="true"
        (valueChange)="onContentsChange($event)"
      ></ai-chatbot-category-chip>

      <ai-chatbot-category-chip
        label="Industry"
        icon="industry"
        [options]="aiChatbotService.industries"
        (valueChange)="onIndustryChange($event)"
      ></ai-chatbot-category-chip>
    </div>
  </div>
  <div class="ai-chatbot-prompt-box-glow"></div>
</div>
